import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import style from './notification.module.css';
import Modal from '@components/common/Modal';
import { LABEL } from '@veriables';
import RightTick from '@assets/images/newUI/Toast/RighttickMobile';
import RightTickDesktop from '@assets/images/newUI/Toast/RightTickDesktop';
import CrossIcon from '@assets/images/crossIcon';
import { NEW_THEME } from '@constants';

const Notification = ({
  isOpen, type, message, mediumSize, okText, paddingCustom, paddingBtnCustom
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  useEffect(() => {
    setmodalOpen(false);
  }, [isOpen]);

  useEffect(() => {
    if (type === 'danger') {
      window.sessionStorage.setItem('setnotification', true);
    }
    return () => window.sessionStorage.removeItem('setnotification');
  }, [isOpen, type, message, modalOpen, okText, paddingCustom, paddingBtnCustom]);


  const isDeskTop = window.innerWidth > 1023;

  const customStyle = {
    padding: '12px',
  };
  const modalStyle = isDeskTop ? customStyle : mediumSize;
  const renderContent = () => (

    <Modal isOpen={!modalOpen} retainModal customStyle={modalStyle}>
      <span className={cn(!isDeskTop && 'pt-1 pr-2', 'd-flex flex-row-reverse')} onClick={() => { setmodalOpen(!modalOpen); }} role="presentation">
        {/* <img src={crossIcon} className={cn('icon-od fs-12 icon-od-close')} alt="crossIcon" aria-label="close" /> */}
        <CrossIcon active="od-iconStyles-actionIcons crossIconDefault" />
      </span>
      <div
        className={cn(!isDeskTop && style.modalPadding, 'mx-0 justify-content-center')}
      >
        <div
          className={cn(isDeskTop && 'text-break-all', 'text-center text-color od-typography-bodytext fs-16 fw-400 pt-30 pb-4')}
          style={{
            ...paddingCustom
          }}
        >
          {message}
        </div>
        <div style={{ ...paddingBtnCustom }}>
          <button
            type="submit"
            className={cn('btn btnLightBlue', NEW_THEME.btnPrime, isDeskTop ? 'col-4 offset-md-4' : 'col-6 offset-3')}
            onClick={() => { setmodalOpen(!modalOpen); window.sessionStorage.removeItem('setnotification'); }}
          >
            {okText || LABEL().OK}
          </button>
        </div>
      </div>
    </Modal>
  );

  const isMobile = window.innerWidth < 1023;
  return (
    <React.Fragment>
      {(type === 'danger' || type === null) ? (
        <>
          {renderContent()}
        </>
      ) : (
        <div className={cn('offset-lg-4 col-lg-4 position-absolute d-flex justify-content-center', isMobile ? 'col-12' : 'col-8')}>
          <div className={cn(!isOpen && 'd-none', style.notificationBar, 'od-alert-message-font-style px-0 row mx-0 col-12', style.notificationOpen, cn(style.alertSuccess))} role="alert">
            <div className={cn(style.imageDiv, 'col-2 px-0 align-items-center justify-content-center toastContainerfill od-toast-containerFill')} style={{ background: '#1BB92B' }}>
              {isMobile ? <RightTick activebackground="od-toast-iconBackgroundFill" /> : <RightTickDesktop activebackground="od-toast-iconBackgroundFill" /> }
            </div>
            <div className={cn('col d-flex align-items-center fw-600 od-toast-backgroundFill  text-color od-toast-text', style.msgColor, window.innerWidth > 1023 ? 'fs-14' : 'fs-12')}>{message}</div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

const mapSateToProps = ({ notification }) => ({
  isOpen: notification.isOpen,
  message: notification.message,
  type: notification.type,
  okText: notification.okText,
  paddingCustom: notification.paddingCustom,
  paddingBtnCustom: notification.paddingBtnCustom
});
export default connect(
  mapSateToProps,
  null
)(Notification);
